import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import { getFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateSchema } = useService();

	const createSchema = (createdData: any) => {
		setShowLoader(true);
		requestCreateSchema(app.appName, { ...createdData }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.externalMessage || 'Error occured while creating the mtt schema'}`, {
						type: 'error'
					});
					setShowLoader(false);
					return;
				}
				showAlert('Mtt Schema created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		createSchema(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: getFormDefaults(), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
